export const unitModalTutorialSteps = [
      {
        target: '#unit-modal-shell',
        title: 'Nuevo registro logístico',
        content:
          'Acá armás una unidad nueva. La carga se ordena en tres partes: chofer, transporte y liquidación.',
        narration:
          'Acá armás una unidad nueva. La carga se ordena en tres partes: chofer, transporte y liquidación.',
        audio: '/tutorials/unidad/01-modal.mp3',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#unit-modal-identity',
        title: 'Vista previa del registro',
        content:
          'Acá ves cómo va quedando la unidad mientras la completás.',
        narration:
          'Acá ves cómo va quedando la unidad mientras la completás.',
        audio: '/tutorials/unidad/02-identidad.mp3',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#unit-modal-driver-section',
        title: 'Bloque Chofer',
        content:
          'Primero cargás el chofer. Acá definís sus datos, su acceso y si queda listo para trabajar.',
        narration: '',
        audio: null,
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#unit-modal-driver-access',
        title: 'Acceso operativo',
        content:
          'Si activás este acceso, el chofer queda con su entrada individual lista. Si todavía no la necesitás, podés dejarlo apagado.',
        narration: '',
        audio: null,
        placement: 'top',
        disableBeacon: true,
      },
      {
        target: '#unit-modal-transport-section',
        title: 'Bloque Transporte',
        content:
          'Después cargás el transporte: alias, tipo, patente, modelo y estado inicial. Podés dejarlo listo solo o ya vincularlo al chofer.',
        narration: '',
        audio: null,
        placement: 'top',
        disableBeacon: true,
      },
      {
        target: '#unit-modal-liquidation-section',
        title: 'Bloque Liquidación',
        content:
          'Por último definís la liquidación del chofer. Si tu plan no la usa o todavía no la querés activar, la podés dejar apagada.',
        narration: '',
        audio: null,
        placement: 'top',
        disableBeacon: true,
      },
];

export default unitModalTutorialSteps;
